<mat-card class="card-style px-6 py-6 pt-0">
  <mat-card-header class="flex justify-between items-center">
    <mat-card-title class=""
      >Associar consultor operacional ao cliente</mat-card-title
    >
    <button class="btn-icon" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-card-header>
  <div class="mt-6">
    <div class="flex justify-end mb-5">
      <button
        mat-flat-button
        class="btn-tg w-1/5"
        [disabled]="!checkForm()"
        (click)="confirmSelection()"
      >
        Confirmar
      </button>
    </div>
    <div>
      @if (!loading) {
        <div>
          <table-list-select
            [dataSource]="itemsList"
            [columns]="columns"
            [multiSelect]="multiSelect"
            [selected]="selected"
            [keyValidator]="'funcionarioId'"
            [listSelected]="listSelected"
            (selectItem)="selectItem($event)"
          />
        </div>
        <div>
          @if (itemsList.length > 0) {
            <pagination
              [currentPage]="page"
              [pageSize]="rows"
              [totalRecords]="numberRows"
              (pageChanged)="pageChanged($event)"
            />
          }
        </div>
      } @else {
        <div>
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
      }
    </div>
  </div>
</mat-card>
